<template>
    <modal
        name="liberar-asientos-abonados"
        transition="pop-out"
        :width="800"
        height="auto"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Liberar los asientos de los abonados no renovados.</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 text-center">
                        <h1 class="font-weight-bold">¿Quieres liberar todos los asientos de los abonados que no hayan renovado?</h1>
                    </div>
                    <div class="col-12 text-center">
                        <Button type="button" name="button" @click="liberarAsientosAbonados">SI, LIBERAR</Button>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>

export default {
    props: [],
    data() {
        return {
        }
    },
    methods: {
        close() {
            this.$emit('close', 'liberar-asientos-abonados');
        },
        liberarAsientosAbonados() {                
            const params = {
                filters : {},
                lista_id: this.$store.getters.getListaId
            };

            this.$store.dispatch(this.config.getVuexAlias('back.lista.liberar.asientos'), params).then(res => {
                this.$toast.success(res.data.message);
                this.close();
            });
        }
    },
}
</script>
